import { css } from '@emotion/react'
import styled from '@emotion/styled'

import { Header, Container } from '../../pages/common'

import VendorCard from "./Components/Card";
import Logo from "../../images/logo.png";

import { useQuery } from '@tanstack/react-query';

import { getAllVendors } from "./apiService";

const Main = styled.main`
  display: flex;
  flex-wrap: wrap;
  gap: 2.5rem;
  /* padding: 2rem; */
`;


const VendorPortal = () => {

  const vendors = [
    {
      name: "Eva & Chloe Wigs",
      logo: Logo,
      address: "123 Main St",
      city: "Buffalo",
      state: "NY",
      zip: "18054",
      phone: "7185468765",
      email: "test@sample.com",
      requestStatus: "None",
      viewAccess: "View",
      requestAccess: "Request Access"
    },
    {
      name: "Mollie Wigs",
      logo: Logo,
      address: "123 Main St",
      city: "Buffalo",
      state: "NY",
      zip: "18054",
      phone: "7185468765",
      email: "test@sample.com",
      requestStatus: "Granted",
      viewAccess: "View",
      requestAccess: "Request Access"
    },
    {
      name: "Tzili Wigs",
      logo: Logo,
      address: "123 Main St",
      city: "Buffalo",
      state: "NY",
      zip: "18054",
      phone: "7185468765",
      email: "test@sample.com",
      requestStatus: "None",
      viewAccess: "View",
      requestAccess: "Request Access"
    },
    {
      name: "Ronit Wigs",
      logo: Logo,
      address: "123 Main St",
      city: "Buffalo",
      state: "NY",
      zip: "18054",
      phone: "7185468765",
      email: "test@sample.com",
      requestStatus: "None",
      viewAccess: "View",
      requestAccess: "Request Access"
    },
    {
      name: "Ashley Wigs",
      logo: Logo,
      address: "123 Main St",
      city: "Buffalo",
      state: "NY",
      zip: "18054",
      phone: "7185468765",
      email: "test@sample.com",
      requestStatus: "None",
      viewAccess: "View",
      requestAccess: "Request Access"
    },
    {
      name: "C Wigs",
      logo: Logo,
      address: "123 Main St",
      city: "Buffalo",
      state: "NY",
      zip: "18054",
      phone: "7185468765",
      email: "test@sample.com",
      requestStatus: "None",
      viewAccess: "View",
      requestAccess: "Request Access"
    },
    {
      name: "Ruchie Wigs",
      logo: Logo,
      address: "123 Main St",
      city: "Buffalo",
      state: "NY",
      zip: "18054",
      phone: "7185468765",
      email: "test@sample.com",
      requestStatus: "None",
      viewAccess: "View",
      requestAccess: "Request Access"
    },
    {
      name: "Esme Wigs",
      logo: Logo,
      address: "123 Main St",
      city: "Buffalo",
      state: "NY",
      zip: "18054",
      phone: "7185468765",
      email: "test@sample.com",
      requestStatus: "None",
      viewAccess: "View",
      requestAccess: "Request Access"
    },
    {
      name: "Millennium Wigs",
      logo: Logo,
      address: "123 Main St",
      city: "Buffalo",
      state: "NY",
      zip: "18054",
      phone: "7185468765",
      email: "test@sample.com",
      requestStatus: "None",
      viewAccess: "View",
      requestAccess: "Request Access"
    },
    {
      name: "Utopia Wigs",
      logo: Logo,
      address: "123 Main St",
      city: "Buffalo",
      state: "NY",
      zip: "18054",
      phone: "7185468765",
      email: "test@sample.com",
      requestStatus: "None",
      viewAccess: "View",
      requestAccess: "Request Access"
    },
    {
      name: "Miri Wigs",
      logo: Logo,
      address: "123 Main St",
      city: "Buffalo",
      state: "NY",
      zip: "18054",
      phone: "7185468765",
      email: "test@sample.com",
      requestStatus: "None",
      viewAccess: "View",
      requestAccess: "Request Access"
    }
  ]

  const { data: integrations } = useQuery({
    queryKey: ['portal', 'vendors'],
    queryFn: () => getAllVendors(),
    refetchOnWindowFocus: false,
    staleTime: Infinity
  })

  return (
    <Container>
      <Header>
        <h2>Welcome to the Vendor Portal</h2>
      </Header>
      <Main>
        {integrations?.map((vendor, index) => <VendorCard key={vendor.name} vendor={vendor} />)}
      </Main>
    </Container>
  );
}

export default VendorPortal;
